import { Optional } from '@/common/domain/Optional';
import { DateTimeInputUi } from '@/common/primary/date/DateTimeInput.ui';

export const toDateToUpdate = (formDate: DateTimeInputUi, oldDate: Date): Optional<Date> =>
  Optional.of<Date>(DateTimeInputUi.toDate(formDate)).filter(date => date.getTime() !== oldDate.getTime());
